export const SCHEMAS = {
	CVReview_1004: 'CVReview:1',
	CVReview_1073: 'CVReview1073:1',
	CVReview_1075: 'CVReview1075:1',
	CVReview_2055: 'CVReview2055:1',
	InspectionReport: 'InspectionReport:3',
	// Custom Schema that groups all Schemas from Altval
	CVReviewAltVal: 'CVReviewAltVal'
};

export const isCVReview = (schema: string): boolean => {
	return /CVReview/.test(schema);
}
